import { brandedConfig } from './branding';

export function getLogo(): string {
  return brandedConfig.logoSvg;
}

export function getAppName(): string {
  return brandedConfig.companyName;
}

export function getAppFullName(): string {
  return brandedConfig.productName;
}
